<template>
  <div class='InputVerifyCode' ref="code">
    <input @input="e => getValue(0, e.target.value)" placeholder="-"/>
    <input @input="e => getValue(1, e.target.value)" placeholder="-"/>
    <input @input="e => getValue(2, e.target.value)" placeholder="-"/>
    <input @input="e => getValue(3, e.target.value)" placeholder="-"/>
    <input @input="e => getValue(4, e.target.value)" placeholder="-"/>
    <input @input="e => getValue(5, e.target.value)" placeholder="-"/>
  </div>
</template>

<script>
export default {
  name: 'InputVerifyCode',
  data () {
    return {
      code: ''
    }
  },
  methods: {
    getValue (key, value) {
      this.code = this.code + value.toString()
      if(key === 5) {
        this.$refs.code.children[key].blur()
        this.$emit('returnValue', this.code)
        return
      }
      this.$refs.code.children[key + 1].focus()
    }
  },
  mounted () {
    this.$refs.code.children[0].focus()
  }
}
</script>

<style scoped>
.InputVerifyCode {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 350px;
  height: 80px;
  margin: auto;
}

input {
  width: 35px;
  height: 40px;
  text-align: center;
  font-size: 18px;
  margin: 8px;
  border: thin solid #CCCCCC;
  border-radius: 5px;
}
</style>
